import { tracked } from '@glimmer/tracking';
import { TrackedArray } from '@ember-compat/tracked-built-ins';

import Utils from '../utils/utils';
import TopologyInput from './general/topology-input';

import cloneDeep from 'lodash.clonedeep';

export default class TopologyInputHandler {
  @tracked all = []; // All of the topology inputs available in the app
  @tracked current = []; // The current topology inputs available for the selected dac

  constructor() {}

  load(topologyInputs) {
    const all = (topologyInputs || []).map((item) => {
      let topologyInput = cloneDeep(item);
      Utils.generateNamingMetadata(topologyInput);

      topologyInput.options.forEach((option) => {
        Utils.generateNamingMetadata(option);
      });

      return topologyInput;
    });

    this.all = new TrackedArray(all);
  }

  handleDacTypeChange(selectedDacType) {
    if (!(selectedDacType && selectedDacType.topologyInputs)) {
      this.current = new TrackedArray([]);
      return;
    }

    const current = this.all
      .filter((input) => selectedDacType.topologyInputs.map((dacInput) => dacInput.id).includes(input.id))
      .map((input) => {
        const dacInput = selectedDacType.topologyInputs.find((dacInput) => dacInput.id === input.id),
          config = Object.assign({ isShown: true }, cloneDeep(input), dacInput.overrides || {});
        return new TopologyInput(config);
      });

    this.current = new TrackedArray(current || []);
  }

  handleTopologyChange(selectedDac) {
    // this may change a selected topology option so anything that requires it must come after
    this.current.forEach((input) => {
      input.resetIsDisabled({ inputs: this.current, selectedDac: selectedDac });
    });
  }

  handleSelectedDacChange(selectedDac, data) {
    this.current.forEach((input) => {
      input.resetDefault({ selectedDac: selectedDac });
      input.resetOptions(data);
      input.resetSelectableOptions({ selectedDac: selectedDac });

      /**
       * The disabled input selected option will be reset with the topology change
       * We don't want to override it here
       **/
      if (!input.isDisabled) input.resetSelectedOption();
    });

    this.handleTopologyChange(selectedDac);
  }
}
